import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useDetailDevice, useUnits } from "../hooks/use-devices";
import { useActiveIncidents } from "../hooks/use-incidents";
import { useLADSDeviceChanged } from "../hooks/use-websocket-lads";
import { DeviceDetail } from "../partials/device-detail.tsx";
import { ErrorScreenWithText } from "../partials/error-screen";
import { LoadingScreenWithText } from "../partials/loading-screen";
import { PagePartial } from "../partials/page-partial.tsx";

export const DetailPage = () => {
  const { deviceId } = useParams<{ deviceId: string }>();
  // key forces full remount when deviceId changes — resets all hook state
  return <DetailPageInner deviceId={deviceId} key={deviceId} />;
};

const DetailPageInner = ({ deviceId }: { deviceId?: string }) => {
  const { t } = useTranslation();
  const { device, error, isLoading } = useDetailDevice(deviceId);
  const {
    error: errorUnits,
    refetch: refetchUnits,
    units = [],
  } = useUnits(deviceId ?? "");
  const { incidents = [] } = useActiveIncidents();

  // Refetch FUs when backend signals attribute change (e.g. DisplayName via SemanticChangeEvent)
  const roomId = device?.location?.room || "";
  useLADSDeviceChanged(
    roomId,
    { onDeviceMetadataChange: refetchUnits },
    !!roomId
  );

  if (isLoading || !device) {
    return <LoadingScreenWithText />;
  }

  if (error || errorUnits) {
    return <ErrorScreenWithText error={error || errorUnits} />;
  }

  return (
    <PagePartial title={`${t("page.workplaces")} / ${device.name}`}>
      <DeviceDetail
        device={device}
        incidents={incidents}
        onRefetchUnits={refetchUnits}
        renderDetailChannelValues
        renderDetailIncidents
        renderDeviceControl
        units={units}
      />
    </PagePartial>
  );
};
